export default __webpack_public_path__ + "static/media/car_light.e1b3b96a.png";